/**
 * The documents a process can start from: the knowledge library's APPROVED
 * documents (status `ready`, which a document reaches only once any review its
 * category requires has passed). One finder for both places that pick a
 * source — the entry screen's "Start from an approved document" and the
 * Studio's source pane — so the two never disagree about what is pickable.
 *
 * Free text goes to the content search, which indexes ready documents only;
 * no text lists the newest ready documents.
 */
import { listDocuments, searchDocuments } from '@/api/documents'

export interface SourceDocument {
  id: string
  title: string
  category: string
  /** When the list projection carries it; search results do not. */
  updatedAt: string | null
}

export function sourceDocumentsKey(query: string) {
  return ['studio', 'documents', query.trim()] as const
}

export async function findSourceDocuments(query: string): Promise<SourceDocument[]> {
  const q = query.trim()
  if (q) {
    const res = await searchDocuments(q)
    return res.results.map((r) => ({ id: r.document_id, title: r.title, category: r.category, updatedAt: null }))
  }
  const res = await listDocuments(undefined, undefined, ['ready'])
  return res.documents.map((d) => ({
    id: d.id,
    title: d.title || d.filename,
    category: d.category,
    updatedAt: d.updated_at,
  }))
}
